import React, { useEffect } from "react";

import "./style.scss";
import authStore from "../../stores/authStore";
import globalStore from "../../global/globalStore";
import homeStore from "../../stores/homeStore";
import { isMobile } from "../../utils/tools";
import { wxLogin } from "../../utils/wx_tools";

interface Props {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  // 只有一个子元素时开启它
  fullMode?: boolean;
}

const Body = (props: Props) => {
  const { style = {}, children = <></>, fullMode = false } = props;
  const { setDialog } = globalStore();
  const { getUserInfo, updateUserInfo, userLoading, userInfo, appInfo } =
    authStore();
  const { fetchEvaluates } = homeStore();

  useEffect(() => {
    if (appInfo.mount) {
      getUserInfo();
    } else {
      updateUserInfo();
    }
  }, [appInfo.mount]);

  useEffect(() => {
    if (!userLoading) {
      if (userInfo.id) {
        // 登录成功后，发送cookie，且登录后要替换存储一次cookie
        fetchEvaluates();
        if (userInfo.isShowedModifyName) {
          setDialog("sure-info", true);
        }
      } else {
        if (isMobile()) {
          wxLogin();
        }
      }
    }
  }, [userLoading]);

  return (
    <div
      style={style}
      className={`good_use-page ${fullMode && "good_use-page--full"}`}
    >
      {children}
    </div>
  );
};

export default Body;
